import { OPERATOR_CODE_LABELS } from "src/constants/operators";
import { useT } from "src/internationalization";
import { OperatorCode } from "src/types/operator";

export const useGetOperatorLabel = () => {
  const t = useT();

  const getOperatorLabel = (operatorCode: OperatorCode) => {
    return t(OPERATOR_CODE_LABELS[operatorCode]);
  };

  return getOperatorLabel;
};
